(() => {
  const prefix = 'ddx_lead_pending:';
  const forms = new Map([['ContactForm', 'general_contact'], ['DDXMailInRequest', 'mail_in_service']]);
  const allowed = new Set(['equipment_quote', 'service_request', 'supply_question', 'general_contact', 'mail_in_service']);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!forms.has(form.id) || !form.checkValidity()) return;
    const selected = form.querySelector('#DDXRequestType')?.value;
    const type = allowed.has(selected) ? selected : forms.get(form.id);
    try {
      sessionStorage.setItem(prefix + form.id, JSON.stringify({type, time: Date.now(), token: crypto.randomUUID()}));
    } catch {}
  }, true);
  const send = () => {
    if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
    if (typeof window.gtag !== 'function') return;
    document.querySelectorAll('[data-ddx-lead-success]').forEach(marker => {
      const id = marker.dataset.ddxLeadSuccess;
      if (!forms.has(id)) return;
      try {
        const record = JSON.parse(sessionStorage.getItem(prefix + id));
        if (!record || !allowed.has(record.type) || Date.now() - record.time > 1800000) return;
        sessionStorage.removeItem(prefix + id);
        window.gtag('event', 'generate_lead', {send_to: 'G-MYZ1YBTWP7', form_id: id, lead_type: record.type});
      } catch {}
    });
  };
  document.addEventListener('visitorConsentCollected', send);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', send, {once: true});
  else send();
  window.addEventListener('load', send, {once: true});
  let checks = 0;
  const readinessCheck = window.setInterval(() => {
    checks += 1;
    send();
    if (checks >= 40 || (typeof window.gtag === 'function' && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.())) {
      window.clearInterval(readinessCheck);
    }
  }, 250);
})();

/* Contact intent only: clicks are not received or qualified leads. */
(() => {
  if (window.__ddxContactIntentTracking) return;
  window.__ddxContactIntentTracking = true;
  document.addEventListener('click', event => {
    if (event.isTrusted === false) return;
    const link = event.target?.closest?.('a[href]');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    const phone = /^tel:/i.test(href);
    const quoteEmail = /^mailto:/i.test(href) && /[?&]subject=[^&]*quote/i.test(href);
    if (!phone && !quoteEmail) return;
    if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
    if (typeof window.gtag !== 'function') return;
    const path = window.location.pathname;
    const product = path.match(/\/products\/([^/]+)\/?$/);
    const placement = link.closest('.product__description') ? 'product_description'
      : link.closest('[id^="ProductInfo-"]') ? 'product_info'
      : link.closest('footer') ? 'footer'
      : link.closest('header') ? 'header' : 'page_content';
    window.gtag('event', phone ? 'phone_click' : 'quote_email_click', {
      send_to: 'G-MYZ1YBTWP7',
      page_path: path,
      product_handle: product ? product[1] : '',
      cta_placement: placement,
      contact_method: phone ? 'phone' : 'email'
    });
  }, true);
})();
